import React from "react";
import AllInventory from "./InventoryModule/AllInventory";

const Inventory = () => {
  return (
    <div>
      <AllInventory />
    </div>
  );
};

export default Inventory;
